"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupedCoordinatePropTypes = exports.coordinatePropTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var coordinatePropTypes = _propTypes["default"].arrayOf(_propTypes["default"].shape({
  x: _propTypes["default"].number.isRequired,
  y: _propTypes["default"].number.isRequired,
  y0: _propTypes["default"].number.isRequired
}));

exports.coordinatePropTypes = coordinatePropTypes;

var groupedCoordinatePropTypes = _propTypes["default"].objectOf(_propTypes["default"].shape({
  average: _propTypes["default"].number,
  averageBatteryPercentage: _propTypes["default"].number,
  charge: _propTypes["default"].number,
  consumption: _propTypes["default"].number,
  contract: _propTypes["default"].number,
  discharge: _propTypes["default"].number,
  estimatedSolar: _propTypes["default"].number,
  exportValue: _propTypes["default"].number,
  maxBattery: _propTypes["default"].number,
  maxPercentage: _propTypes["default"].number,
  minBattery: _propTypes["default"].number,
  minPercentage: _propTypes["default"].number,
  peer: _propTypes["default"].number,
  peerV2: _propTypes["default"].number,
  selfConsumption: _propTypes["default"].number,
  site: _propTypes["default"].number,
  solar: _propTypes["default"].number,
  systemProduction: _propTypes["default"].number,
  x: _propTypes["default"].number.isRequired,
  y: _propTypes["default"].number.isRequired
}));

exports.groupedCoordinatePropTypes = groupedCoordinatePropTypes;